import { Injectable } from '@angular/core';
import { JwtService } from './jwt.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class HasTokenResolver {
  constructor(
    private jwtService: JwtService,
    private router: Router
  ) { }
  resolve(): any {
    if (this.jwtService.IsAuthUser()) {
      this.router.navigate(["/dashboard"]);
    }
  }
}

@Injectable()
export class AppRoutingAccess {
  constructor(
    private jwtService: JwtService,
    private router: Router
  ) { }
  resolve(): any {
    if (!this.jwtService.IsAuthUser()) {
      this.jwtService.deleteLocalStorage();
    }
  }
}

@Injectable()
export class AppCheckUserAlreadyLogin {
  constructor(
    private jwtService: JwtService,
    private router: Router
  ) { }
  resolve(): any {
    if (this.jwtService.IsAuthUser()) {
      this.router.navigate(["/dashboard"]);
    }
  }
}